import { GlobalSettingsDataProvider } from '../GlobalSettingsProvider';
import fallbackGlobalSettingsDataProvider from './FallbackGlobalSettingsDP';

export const getGlobalSettingsDataProvider = (): GlobalSettingsDataProvider => {
  return fallbackGlobalSettingsDataProvider;
};
